module.exports = __webpack_public_path__ + "static/media/back1svg.d4312ac8.svg";